import classnames from 'classnames';
import type { FunctionComponent } from 'react';
import { Text } from '@/core/tamagoshi/Text/Text';
import { translate } from '@/domains/core/localization/translate';
import styles from './reviewPurchaseDate.module.scss';
const {
  purchaseDateTranslation
} = translate({
  "purchaseDateTranslation": "Purchase date:"
});
interface Props {
  purchasedAt: string | null;
  className?: string;
}
export const ReviewPurchaseDate: FunctionComponent<Props> = ({
  purchasedAt,
  className
}) => {
  if (!purchasedAt) return null;
  const purchaseDate = new Date(purchasedAt);
  const date = `${String(purchaseDate.getDate()).padStart(2, '0')}/${String(purchaseDate.getMonth() + 1).padStart(2, '0')}/${purchaseDate.getFullYear()}`;
  return <Text type="small" className={classnames(styles.container, className)}>
      {`${purchaseDateTranslation} ${date}`}
    </Text>;
};